import DocumentPage from "../../../../invoice/DocumentPage";
import { sdiCreditNoteConfig } from "./config";

const SDICreditNote = () => <DocumentPage config={sdiCreditNoteConfig} />;

export default SDICreditNote;